import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tooltip)?_c(VTooltip,{attrs:{"top":"","transition":"fade-transition"},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c(VIcon,_vm._g({attrs:{"small":"","color":_vm.iconColor}},on),[_vm._v(_vm._s(_vm.icon))])]}}],null,false,4152191468)},[_c('span',[_vm._v(_vm._s(_vm.$t(`labels.${_vm.complianceState}`)))])]):_c(VIcon,{attrs:{"small":"","color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))])
}
var staticRenderFns = []

export { render, staticRenderFns }